<template></template>

<script>
import { userLogin } from '../../api/index';
import configHttp from '../../../configHttp.js'
export default {
	name: 'Login',
	created() {
		let enableFamilyLogin=configHttp.enableFamilyLogin
		let param = this.getRequestParam();
		let requestParamToken = param["token"];
		let portalLogin = localStorage.getItem("portalLogin");
		localStorage.clear();
		if(enableFamilyLogin) { // 产品单点登录跳转
			if(requestParamToken || portalLogin=="true"){
				this.productRedirect();
			}
		}
	},
	methods: {
		/* 	获取用户展示权限菜单 */
		getCurrentUserMenuFunction() {
			let params = {};
			this.$https.fetchPost('sys/admin/getRoleMenuIdListByUser', params).then(res => {
				if (res.data.success) {
					localStorage.setItem('routearr', res.data.obj.routearr);
					localStorage.setItem('userFunction', JSON.stringify(res.data.obj.userFunction));
                    this.saveStorageButton(res.data.obj.userFunction);
					this.$router.push('/');
				}
			});
		},
        saveStorageButton(data){
            let buttonIds = [];
            let userFunction = data;
            for (let i = 0; i < userFunction.length; i++) {
                if (userFunction[i].hasOwnProperty("children")) {
                    let pageButtons = userFunction[i].children;
                    for (let j = 0; j < pageButtons.length; j++) {
                        if (pageButtons[j].hasOwnProperty("buttomroute")) {
                            let keys= Object.keys(pageButtons[j].buttomroute);
                            if (keys.length <= 0){continue}
                            let buttonObjs = pageButtons[j].buttomroute;
                            for (let key of keys) {
                                buttonIds.push(key);
                                let btnKeys= Object.keys(buttonObjs[key]);
                                if (btnKeys.length <= 0){continue}
                                for (let btnKey of btnKeys) {
                                    if (buttonObjs[key][btnKey]) {
                                        buttonIds.push(btnKey);
                                    }
                                }
                            }
                        }
                    }
                }
            }
            localStorage.setItem('buttonIds', JSON.stringify(buttonIds));
        },
		async productRedirect() {	// 产品单点登录

			localStorage.setItem("portalLogin","true");
			let requestParam = this.getRequestParam();
			let token = requestParam['token'];
			console.log("token : " + token)
			if (token && token.length > 0) {
				localStorage.setItem('token', token);
			} else {
				token = localStorage.getItem('token')
			}
			if (token && token != "null") {
				console.log("token : " + token)
				this.$https.fetchPost('sys/familyLogin?token=' + token).then(res => {
					if (res.data.success) {
						console.log("token : " + res.data.obj.token)
						localStorage.setItem('token', res.data.obj.token);
						console.log(res.data.obj.user)
						localStorage.setItem('useropj', res.data.obj.user);
						this.getCurrentUserMenuFunction();
					}
				});
			} else {
				localStorage.clear();
				window.location.href = configHttp.familyLoginUrl
			}

		},
		getRequestParam() {   //  获取请求后面的参数
			var requestParam = new Object();
			if(location.href.indexOf('?') != -1) {
				var url = location.href.substring(location.href.indexOf('?')); //获取url中"?"符后的字串
				var str = url.substr(1);
				let strs = str.split("&");
				for (var i = 0; i < strs.length; i++) {
					requestParam[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]); //获取中文参数转码<span style="font-family: Arial, Helvetica, sans-serif;">decodeURI</span>，（unescape只针对数字，中文乱码)
				}
			}
			return requestParam;
		}
	}
};
</script>